<script src='form-input-autocomplete.component.ts'></script>
<div class="form-group searching" [ngClass]="{ 'has-error': error, searching: searching }">
    <mat-form-field class="w-100" appearance="fill" subscriptSizing="dynamic">
        <input
            [type]="type"
            class="form-control"
            placeholder="{{ placeholder | translate }}"
            [disabled]="disable"
            [readonly]="readonly"
            [(ngModel)]="value"
            container="body"
            [popover]
            [adaptivePosition]="false"
            containerClass="error popover-compact"
            triggers="mouseenter:mouseleave"
            (keyup)="onChange($event)"
            matInput
            [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayAddress" (opened)="onOpen()"
                          (closed)="onClose()">
            @for (option of addressSuggestions; track option) {
                <mat-option
                    [value]="option"
                    appTitleProvider
                    (onSelectionChange)="onChange($event)">
                    {{ displayAddressAndZipCode(option) }}
                </mat-option>
            }
        </mat-autocomplete>
        @if (searching) {
            <span class="spinner spinner-sm"></span>
        }
    </mat-form-field>
</div>
